<template>
    <div
        v-cloak
        :id="`component-${component.id}`"
        class="no-break-item d-print-none"
    >
        <div
            class="card mb-4 no-break"
            :class="[
                `type-${(component.type ? component.type.slug : '')}`,
            ]"
        >
            <h5 class="card-header d-flex align-items-center">
                <img
                    v-if="component.icon"
                    :src="component.icon"
                    width="35"
                    class="icon me-2 float-start"
                    loading="lazy"
                />

                <div>
                    {{ componentTitle }}

                    <small
                        v-if="(! hasTranslation) && languageId && (Number(languageId) !== Number($app.translationEnglishId))"
                        class="text-muted"
                    >
                        <br/>
                        {{ $t('noTranslations') }}
                    </small>
                </div>
            </h5>
            <div class="card-body">
                <div v-html="componentContent"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ComponentItem",

    props: {
        component: {
            type: Object,
            required: true,
        },

        languageId: {
            type: [Number, String],
            default: null,
        },
    },

    computed: {
        hasTranslation() {
            return (this.component.translations && this.component.translations.length);
        },

        componentTitle() {
            return (this.hasTranslation ? this.component.translations[0].title : this.component.title);
        },

        componentContent() {
            return (this.hasTranslation ? this.component.translations[0].content : this.component.content);
        },
    },
};
</script>

<style>
    .type-reflect
    {
        background-color: #FFF799;
    }
</style>
